import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => ({
    root: {
      ...typography.heading.h3,
      color: palette.grey.shade[90],
      fontWeight: typography.fontWeightBold,
      marginTop: spacing(7),
      marginBottom: spacing(5)
    }
  })
)

const CompleteHeader = ({ title }) => {
  const classes = useStyles()
  return (
    <Typography
      align='center'
      component='h1'
      data-test='retention-complete-heading'
      className={classes.root}
    >
      {title}
    </Typography>
  )
}

export default CompleteHeader
